<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
    <div class="flex flex-row items-center">
        <h2 mat-dialog-title class="!pl-0 dialog-heading capitalize">{{this.heading}}</h2>
    </div>
    <button mat-icon-button (click)="this._matDialogRef.close()"
        class="dialog-close-btn flex items-center justify-center">
        <mat-icon class="text-orange-color text-xl">close</mat-icon>
    </button>
</div>

<mat-dialog-content class="mt-16 pt-0 pl-3">
    <mat-radio-group [(ngModel)]="selectedReason" aria-label="Select an option" class="flex pt-2 flex-col gap-2">
        <ng-container *ngFor="let item of this.reasons">
            <mat-radio-button class="text-black-color matradiotext" [value]="item.id">{{item.title}}</mat-radio-button>
        </ng-container>
    </mat-radio-group>
    <div @showHide *ngIf="selectedReason == 10" class="row mt-4">
        <mat-form-field class="flex-1 form-field" appearance="fill">
            <label class="label font-medium leading-4">Type Reason</label>
            <input [formControl]="otherReason" type="text" matInput class="form-control" placeholder="Type Here...">
            <mat-error>Please provide a valid reason.</mat-error>
        </mat-form-field>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="m-0 !pb-5 !px-5 flex md:justify-center sm:justify-center justify-center">
    <button color="primary" (click)="onSubmit()" class="!bg-orange-color !px-6 !h-11 text-white-color ml-auto mr-0"
        mat-flat-button>
        <span class="btn-text">Cancel Order</span>
    </button>
</mat-dialog-actions>